// extracted by css-extract-rspack-plugin
export default {"cls1":"TruncateText-cls1_o-R","cls2":"TruncateText-cls2_IPb TruncateText-cls1_o-R"};